import React from 'react';
import { ApiReportStepStatus } from '@/api/types/models.types';
import {
  getStatusDescription,
  getStatusText,
} from '@/helpers/staticText';
import { SVGIcon } from '../SVGIcon';

export interface OrderBodyProps {
  status: ApiReportStepStatus;
  inspectionDate?: Date;
  reportAccessLinkId?: string;
}

const formatInspectionDate = (date: Date): string => {
  const dayNames = [
    'niedziela', 'poniedziałek', 'wtorek', 'środa',
    'czwartek', 'piątek', 'sobota',
  ];
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const dayName = dayNames[date.getDay()];
  return `${day}.${month}.${year} (${dayName})`;
};

// [869dwu892] Sekcję statusu (tytuł + opis) pokazujemy do statusu
// "Generowanie raportu" (krok 4) włącznie. Po udostępnieniu raportu
// (krok 5) cała sekcja pozostaje ukryta.
const STATUSES_WITH_ORDER_BODY: ApiReportStepStatus[] = ['krok 1', 'krok 2', 'krok 3', 'krok 4'];

// [869dfpz4x] Planowany termin oględzin pokazujemy tylko do statusu
// "Zlecenie przyjęte do realizacji" (krok 2). Od oględzin w górę (krok 3+) ukryty.
const STATUSES_WITH_INSPECTION_DATE: ApiReportStepStatus[] = ['krok 1', 'krok 2'];

export const OrderBody: React.FC<OrderBodyProps> = ({ status, inspectionDate }) => {
  if (!STATUSES_WITH_ORDER_BODY.includes(status)) {
    return null;
  }

  const showInspectionDate =
    !!inspectionDate && STATUSES_WITH_INSPECTION_DATE.includes(status);

  return (
    <>
      <div className="flex w-full flex-col items-start gap-5 bg-white pb-9 pt-12 md:pb-[80px] md:pt-[47px]">
        <section className="container flex flex-col gap-2 items-start">
          <span className="w-full font-inter text-xs font-bold uppercase tracking-[0.1px] text-blue">
            Status zamówienia:
          </span>
          <h2 className="w-full font-archivo text-lg font-semibold leading-5 tracking-[0.3px] text-text-primary md:text-xl md:leading-[38px] lg:text-[26px]">
            {getStatusText(status)}
          </h2>
          <p
            className="w-full font-normal leading-6 fluid-text-sm font-inter text-text-primary md:leading-7"
            dangerouslySetInnerHTML={{
              __html: getStatusDescription(status),
            }}
          ></p>

          {showInspectionDate && (
            <div className="flex items-center w-full gap-2.5 px-8 py-6 mt-6 rounded-[15px] bg-primary-50">
              <SVGIcon name="calendar-date" size={'lg'} fill="#444F58" className="flex-shrink-0" />
              <p className="pl-6 text-sm lg:text-base font-inter text-text-primary">
                Planowana data przeprowadzenia oględzin:{' '}
                <span className="text-base font-semibold lg:text-lg text-blue">
                  {formatInspectionDate(inspectionDate)}
                </span>
              </p>
            </div>
          )}
        </section>
      </div>

    </>
  );
};
